// skeleton/app/src/app/shared/components/base/header/header.component.ts

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LogoutServive } from '../../../../logout/logout.service';
import { SiteminderAuthService } from 'src/app/auth/oidc-config.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  userLoginStatus: boolean = false;

  constructor(
    private router: Router,
    private logoutservice: LogoutServive,
    private siteminderAuthService: SiteminderAuthService
  ) {}

  ngOnInit(): void {
    try {
      this.logoutservice.currentUserLogin.subscribe({
        next: (message) => {
          try {
            this.userLoginStatus = message;
          } catch (error) {
            this.logError(
              'Header login status processing failed',
              error
            );
          }
        },
        error: (error) => {
          this.logError(
            'Header login status subscription failed',
            error
          );
        },
      });

      let isSiteminderValid = false;

      try {
        isSiteminderValid =
          this.siteminderAuthService.isTokenValid();
      } catch (error) {
        this.logError(
          'SiteMinder token validation failed',
          error
        );

        isSiteminderValid = false;
      }

      if (isSiteminderValid) {
        this.userLoginStatus = true;
      } else if (
        window.location.href.includes(
          'resetpassword'
        )
      ) {
        this.userLoginStatus = false;
      }

      this.toggle();
    } catch (error) {
      this.logError(
        'Header initialization failed',
        error
      );
    }
  }

  toggle(): void {
    try {
      const item =
        document
          .getElementsByClassName(
            'nav-list'
          )
          .item(0) as HTMLElement | null;

      if (!item) {
        return;
      }

      if (
        item.style.display ===
        'none'
      ) {
        item.style.display =
          'block';

        item.style.visibility =
          'visible';

        item.style.opacity = '1';

        document
          .getElementById(
            'nav-toggle'
          )
          ?.classList.add(
            'active'
          );
      } else {
        item.style.display =
          'none';

        item.style.visibility =
          'hidden';

        item.style.opacity = '0';

        document
          .getElementById(
            'nav-toggle'
          )
          ?.classList.remove(
            'active'
          );
      }
    } catch (error) {
      this.logError(
        'Header toggle failed',
        error
      );
    }
  }

  redirectAction(): void {
    try {
      let isSiteminderValid = false;

      try {
        isSiteminderValid =
          this.siteminderAuthService.isTokenValid();
      } catch (error) {
        this.logError(
          'SiteMinder redirect validation failed',
          error
        );

        isSiteminderValid = false;
      }

      if (isSiteminderValid) {
        this.router.navigate([
          '/reports',
        ]);

        return;
      }

      this.router.navigate([
        '/home',
      ]);
    } catch (error) {
      this.logError(
        'Header redirect failed',
        error
      );
    }
  }

  private logError(
    context: string,
    error: unknown
  ): void {
    try {
      const messages: string[] =
        [];

      let currentError: unknown =
        error;

      let depth = 0;

      while (
        currentError &&
        depth < 5
      ) {
        if (
          currentError instanceof
          Error
        ) {
          messages.push(
            currentError.message ||
              currentError.name
          );

          const nestedError =
            currentError as Error & {
              cause?: unknown;
              innerException?: unknown;
              innerError?: unknown;
            };

          currentError =
            nestedError.cause ??
            nestedError.innerException ??
            nestedError.innerError ??
            null;
        } else if (
          typeof currentError ===
            'object' &&
          currentError !== null &&
          'message' in currentError &&
          typeof (
            currentError as {
              message?: unknown;
            }
          ).message === 'string'
        ) {
          messages.push(
            (
              currentError as {
                message: string;
              }
            ).message
          );

          currentError = null;
        } else {
          messages.push(
            'Unknown error'
          );

          currentError = null;
        }

        depth++;
      }

      console.error(
        `${context}${
          messages.length
            ? `: ${messages.join(
                ' | '
              )}`
            : ''
        }`
      );
    } catch {
      console.error(context);
    }
  }
}